'use strict';

function toInteger (value, fallback) {
    var parsed = parseInt(value, 10);
    return isNaN(parsed) ? fallback : parsed;
}

function applyVisibility (cards, visibleCount) {
    for (var i = 0; i < cards.length; i++) {
        if (i < visibleCount) {
            cards[i].classList.remove('cc-liveShoppingEnded-card--hidden');
        } else {
            cards[i].classList.add('cc-liveShoppingEnded-card--hidden');
        }
    }
}

function setActionsVisibility (actions, isVisible) {
    if (!actions) {
        return;
    }

    actions.hidden = !isVisible;
    actions.style.display = isVisible ? 'flex' : 'none';
}

function removeActions (actions) {
    if (!actions || !actions.parentNode) {
        return;
    }

    actions.parentNode.removeChild(actions);
}

function initEndedGrid (grid) {
    if (grid.getAttribute('data-ended-initialized') === 'true') {
        return;
    }

    var cards = grid.querySelectorAll('.js-liveShoppingEndedCard');
    if (!cards.length) {
        return;
    }

    if (
        window.liveShoppingBambuser &&
        typeof window.liveShoppingBambuser.bindAll === 'function'
    ) {
        window.liveShoppingBambuser.bindAll(grid);
    }

    var initialCount = toInteger(grid.getAttribute('data-initial-count'), 8);
    var stepCount = toInteger(grid.getAttribute('data-step-count'), 8);
    var actions = grid.parentElement.querySelector(
        '.js-liveShoppingEndedActions',
    );
    var button = actions
        ? actions.querySelector('.js-liveShoppingEndedShowMore')
        : null;

    var labelMore = button
        ? button.getAttribute('data-label-more')
        : 'Show more';

    var visibleCount = Math.min(initialCount, cards.length);

    applyVisibility(cards, visibleCount);

    if (!button || !actions) {
        grid.setAttribute('data-ended-initialized', 'true');
        return;
    }

    button.textContent = labelMore;

    if (cards.length <= initialCount) {
        removeActions(actions);
        grid.setAttribute('data-ended-initialized', 'true');
        return;
    }

    setActionsVisibility(actions, true);

    button.addEventListener('click', function () {
        if (visibleCount >= cards.length) {
            removeActions(actions);
            return;
        }

        visibleCount = Math.min(visibleCount + stepCount, cards.length);
        applyVisibility(cards, visibleCount);
        button.textContent = labelMore;

        if (visibleCount >= cards.length) {
            removeActions(actions);
        }

        if (
            window.liveShoppingBambuser &&
            typeof window.liveShoppingBambuser.bindAll === 'function'
        ) {
            window.liveShoppingBambuser.bindAll(grid);
        }
    });

    grid.setAttribute('data-ended-initialized', 'true');
}

function initEndedBanners () {
    initEndedSection(document);
}

function initEndedSection (container) {
    var root = container || document;
    var grids = root.querySelectorAll('.js-liveShoppingEndedGrid');

    for (var i = 0; i < grids.length; i++) {
        initEndedGrid(grids[i]);
    }
}

module.exports = {
    initEndedSection: initEndedSection,
    initEndedBanners: initEndedBanners,
};

document.addEventListener('DOMContentLoaded', initEndedBanners);
